// Updated: 04/15/2024
export const HEALTH_INSURANCE_STEPS = [
  "start_application",
  "primary_address",
  "current_coverage",
  "current_team",
  "current_insurance_info",
  "cobra_partcipants",
];

export const HEALTH_INSURANCE_STEPS_WITH_CORE_APP_OFFER_HI = [
  "start_application",
  "current_coverage",
  "current_team",
  "upload_documents",
  "cobra_partcipants",
];

export const HEALTH_INSURANCE_STEPS_WITH_CORE_APP_WITHOUT_HI = [
  "start_application",
  "current_team",
];

export const HEALTH_INSURANCE_STEPS_WITH_CORE_APP_OFFER_HI_LABELS: {
  [key: string]: string;
} = {
  current_coverage: "Current coverage",
  current_team: "Employee and dependents",
  upload_documents: "Upload documents",
  cobra_partcipants: "COBRA partcipants",
};

export const HEALTH_INSURANCE_STEPS_WITH_CORE_APP_WITHOUT_HI_LABELS: {
  [key: string]: string;
} = {
  current_team: "Employee and dependents",
};

export const HEALTH_STEP_LABELS: { [key: string]: string } = {
  primary_address: "Primary business address",
  current_coverage: "Current coverage",
  current_team: "Current team",
  current_insurance_info: "Current health insurance",
  cobra_partcipants: "COBRA partcipants",
};

export const HEALTH_INSURANCE_STEPS_PLACEHOLDER_WITH_CORE_APP_OFFER_HI =
  HEALTH_INSURANCE_STEPS_WITH_CORE_APP_OFFER_HI.map((step) => ({
    label: HEALTH_INSURANCE_STEPS_WITH_CORE_APP_OFFER_HI_LABELS[step] || "",
  })).filter((step) => !!step.label);

export const HEALTH_INSURANCE_STEPS_PLACEHOLDER_WITH_CORE_APP_WITHOUT_HI =
  HEALTH_INSURANCE_STEPS_WITH_CORE_APP_WITHOUT_HI.map((step) => ({
    label: HEALTH_INSURANCE_STEPS_WITH_CORE_APP_WITHOUT_HI_LABELS[step] || "",
  })).filter((step) => !!step.label);

export const HEALTH_INSURANCE_STEPS_PLACEHOLDER = HEALTH_INSURANCE_STEPS.map(
  (step) => ({
    label: HEALTH_STEP_LABELS[step] || "",
  })
).filter((step) => !!step.label);

// Updated: 03/03/2024
export const MDV_UPSELL_STEPS = [];

// Updated: 05/15/2024
export const WORKERS_COMPENSATION_STEPS = [
  "business_details",
  "business_address",
  "employee_list",
  "employee_activity_information",
  "about_business",
  "business_attributes",
  "documents",
  "epli",
  "review",
];

// Updated: 07/15/2025
export const WORKERS_COMPENSATION_STEPS_WITH_CORE_APP = [
  "business_details",
  "employee_list",
  "employee_activity_information",
  "about_business",
  "business_attributes",
  "documents",
  "epli",
  "review",
];

export const WORKERS_COMP_STEP_LABELS: { [key: string]: string } = {
  business_details: "Business details",
  business_address: "Office location",
  employee_list: "Company staff",
  employee_activity_information: "About your team",
  about_business: "About your business",
  business_attributes: "Business attributes",
  documents: "Attach documents",
  epli: "Employment Practice Liability Insurance (EPLI)",
  review: "Review & submit",
};

export const WORKERS_COMP_STEP_LABELS_PREFILL: { [key: string]: string } = {
  business_details: "Business details",
  business_address: "Office location",
  employee_list: "Update your team info",
  employee_activity_information: "About your team",
  about_business: "About your business",
  business_attributes: "Business attributes",
  documents: "Attach documents",
  epli: "Employment Practice Liability Insurance (EPLI)",
  review: "Review & submit",
};

export const WORKERS_COMP_STEP_LABELS_WITH_CORE_APP: { [key: string]: string } =
  {
    business_details: "Business details",
    employee_list: "Update your team info",
    employee_activity_information: "About your team",
    about_business: "About your business",
    business_attributes: "Business attributes",
    documents: "Attach documents",
    epli: "Employment Practice Liability Insurance (EPLI)",
    review: "Review & submit",
  };

// When an application is being created, let's show the first step of the flow
export const placeholderWCStepData = {
  application_uuid: "",
  last_step_name:
    WORKERS_COMPENSATION_STEPS[WORKERS_COMPENSATION_STEPS.length - 1],
  last_step_name_completed: null,
  current_step: 0,
  total_steps: WORKERS_COMPENSATION_STEPS.length,
  status: "in_progress",
  steps: WORKERS_COMPENSATION_STEPS.map((step) => ({
    step_name: step,
    completed: false,
  })),
  submission_date: null,
  created_at: new Date().toISOString(),
};

export const placeholderWCStepDataWithCoreApp = {
  application_uuid: "",
  last_step_name:
    WORKERS_COMPENSATION_STEPS_WITH_CORE_APP[
      WORKERS_COMPENSATION_STEPS_WITH_CORE_APP.length - 1
    ],
  last_step_name_completed: null,
  current_step: 0,
  total_steps: WORKERS_COMPENSATION_STEPS_WITH_CORE_APP.length,
  status: "in_progress",
  steps: WORKERS_COMPENSATION_STEPS_WITH_CORE_APP.map((step) => ({
    step_name: step,
    completed: false,
  })),
  submission_date: null,
  created_at: new Date().toISOString(),
};
